import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Scale, Save, ExternalLink } from "lucide-react";
import { http, formatApiError } from "../lib/api";

const FIELDS = [["publisher", "Directeur de la publication", "Ex. Prénom NOM, gérant"], ["host_name", "Hébergeur", "Emergent"],
  ["host_address", "Adresse de l'hébergeur", "Adresse postale de l'hébergeur"], ["host_website", "Site de l'hébergeur", "https://…"]];

export const LegalSettings = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [co, setCo] = useState({});
  useEffect(() => {
    http.get("/settings/legal").then((r) => setD(r.data)).catch(() => {});
    http.get("/settings/company").then((r) => setCo(r.data)).catch(() => {});
  }, []);
  if (!d) return null;
  const missing = [["address", "adresse du siège"], ["siret", "SIRET"], ["phone", "téléphone"], ["email", "email"]].filter(([k]) => !co[k]).map(([, l]) => l)
    .concat([["publisher", "directeur de la publication"], ["host_address", "adresse de l'hébergeur"]].filter(([k]) => !d[k]).map(([, l]) => l));
  const save = async () => {
    setBusy(true);
    try { setD((await http.put("/settings/legal", d)).data); toast.success("Mentions légales enregistrées"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="legal-settings" className="border border-slate-200 bg-white rounded-md p-6 space-y-4">
      <div className="flex items-center gap-2"><Scale className="h-5 w-5 text-slate-700" /><h3 className="font-display text-lg font-extrabold">Mentions légales</h3>
        <a data-testid="legal-settings-open" href="/mentions-legales" target="_blank" rel="noreferrer" className="ml-auto inline-flex items-center gap-1 text-xs font-semibold text-sky-700 hover:underline"><ExternalLink className="h-3.5 w-3.5" />Voir la page publique</a></div>
      <p className="text-xs text-slate-500 -mt-2">Page publique <code>/mentions-legales</code>. Raison sociale, siège, SIRET, RCS, TVA, téléphone, email et autorisation CNAPS sont repris de « Informations société ». Couleurs identiques à la politique de confidentialité.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, l, ph]) => (
          <label key={k} className="block"><div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1">{l}</div>
            <input data-testid={`legal-${k}`} value={d[k] || ""} placeholder={ph} onChange={(e) => setD({ ...d, [k]: e.target.value })} className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm" /></label>
        ))}
      </div>
      {missing.length > 0 && <p data-testid="legal-missing" className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">Informations manquantes pour des mentions complètes (LCEN) : {missing.join(", ")}. Complétez-les ici ou dans « Informations société ».</p>}
      <div className="flex"><button type="button" data-testid="legal-save" onClick={save} disabled={busy} className="ml-auto inline-flex items-center gap-1.5 bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-semibold disabled:opacity-60"><Save className="h-4 w-4" />Enregistrer</button></div>
    </div>
  );
};
